import { dealFragments } from '../dealFragments'
import { useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { useTranslation } from 'react-i18next'
import { useMutationShowingErrors } from '@/hooks'
import { Deal, Mutation, MutationSetPayedAndStoredArgs } from '@/schemaTypes'

const SET_DEAL_PAYED_AND_STORED = gql`
  mutation setPayedAndStored($dealId: ObjectId!) {
    setPayedAndStored(dealId: $dealId) {
      _id
      events {
        ...DealEventFragment
      }
    }
  }
  ${dealFragments.event}
`

type TData = { setPayedAndStored: Mutation['setPayedAndStored'] }
type TVariables = MutationSetPayedAndStoredArgs

export function useOnDealStatusPayedAndStored(deal: Deal) {
  const { t } = useTranslation()

  const [setPayedAndStored] = useMutation<TData, TVariables>(
    SET_DEAL_PAYED_AND_STORED,
    {
      variables: { dealId: deal._id },
    },
  )

  return useMutationShowingErrors({
    mutation: setPayedAndStored,
    successMessage: t('update_successful'),
  })
}
